// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__1VIJC","label":"SetPasswdForm_label__5YIHX"};